import { EligibleSurvey } from 'api-models'
import { ApiClient } from '../api-client'

const getEligible = async (): Promise<EligibleSurvey[]> => {
	const { data } = await ApiClient.client.get('/surveys/eligible')
	return data.data
}

const submitResponse = async (
	surveyId: string,
	payload: { rating: number; feedback: string; account_id: string }
): Promise<void> => {
	await ApiClient.client.post(`/surveys/${surveyId}/response`, payload)
}

const dismiss = async (surveyId: string, accountId: string): Promise<void> => {
	await ApiClient.client.post(`/surveys/${surveyId}/dismiss`, { account_id: accountId })
}

const impression = async (surveyId: string, accountId: string): Promise<void> => {
	await ApiClient.client.post(`/surveys/${surveyId}/impression`, { account_id: accountId })
}

export const Surveys = {
	getEligible,
	submitResponse,
	dismiss,
	impression
}
